import {useQuery, UseQueryResult} from '@tanstack/react-query'

import {QueryKeyName, getActionsByPlantId} from '../../common/backend'
import {ActionItem} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const usePlantActions = (): UseQueryResult<ActionItem[]> => {
  const plantId = usePlantUpmId()
  return useQuery({
    queryKey: [QueryKeyName.GetActionItems, plantId],
    queryFn: () => getActionsByPlantId(plantId)
  })
}
